import { createRoot } from 'react-dom';
import './style/theme.css'; // tokens do design system (fonte única) — carrega cedo
import App from './App';
import { instalarLogs } from './utils/logs';

// Logs do Sistema: headers X-Tela/X-Request-Id nas APIs próprias + erros do front → /logs/front
instalarLogs();

const root = document.getElementById('root');
const rootElement = createRoot(root);
rootElement.render(<App />);
